import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Grid } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { Helmet } from "react-helmet";
import ContractsMainTableHeader from "./contracts-main-table-header";
import ContractsMainTableRow from "./contracts-main-table-row";
import * as api from "../../api";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";

function mapStateToProps(state) {
    return {

    };
}


class Contracts extends Component {

    constructor(props){
        super(props);

        this.state = {
            dataProvider: new ApiDataProvider(api.getContractsList, [this.props.customerId]),
        }
    }

    render() {
        return (
            <div className="main-container">
                <Helmet>
                    <title>Insite | Contracts</title>
                </Helmet>
                <Grid padded stackable columns='equal' verticalAlign='middle'>
                    <Grid.Row>
                        <Grid.Column>
                            <div className="table-container">
                                <FilterableDatatable dataProvider={this.state.dataProvider} name="contracts" canExport={true}
                                                     headerComponent={ContractsMainTableHeader} rowComponent={ContractsMainTableRow} contextData={{customerId: this.props.customerId}}/>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
)(Contracts);